<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Personas</h4>
    <hr />

    <DataTable
      :data="personas"
      :columns="[
        { label: 'Documento',  field: 'documento' },
        { label: 'Nombre',     field: 'nombreCompleto' },
        { label: 'Teléfono',   field: 'telefono' },
        { label: 'E-mail',     field: 'email' },
      ]"
      idField="idPersona"
      mensajeVacio="No hay registros de personas."
      :mostrarEditar="opcionMenu == 1"
      :mostrarVer="opcionMenu == 1"
      :mostrarEliminar="opcionMenu == 1"
      :mostrarBotonNuevo="opcionConsulta == 1"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idPersona)"
      @view="row => abrirEditar(row.idPersona)"
      @delete="row => deletePersona(row.idPersona)"
    >
      <!-- Búsqueda extra en barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto" v-if="opcionConsulta == 1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="cedulaBusqueda"
            @input="clearFields('cedula')"
            @keyup.enter="buscar"
            placeholder="Cédula..."
            style="width:150px"
          />
        </div>
        <div class="col-auto" v-if="opcionConsulta == 1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            @input="clearFields('nombre')"
            @keyup.enter="buscar"
            placeholder="Nombre..."
            style="width:250px"
          />
        </div>
        <div class="col-auto" v-if="opcionConsulta == 1">
          <button
            class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click.prevent="buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
            Buscar
          </button>
        </div>
      </template>

      <!-- Acciones extra por fila -->
      <template #acciones-fila="{ row }" v-if="opcionMenu == 1">
        <button
          class="btn btn-sm btn-outline-success"
          @click="crearCita(row.idPersona)"
          title="Nueva Cita"
        >
          <span class="material-icons" style="font-size:14px">event</span>
        </button>
        <button
          class="btn btn-sm btn-outline-info"
          @click="crearNotificacion(row.idPersona, row.nombreCompleto)"
          title="Nueva Notificación"
        >
          <span class="material-icons" style="font-size:14px">notifications</span>
        </button>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled />
                </div>
              </div>
            </div>
            <!-- Fila: Tipo Id / Documento / Estado Civil -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Tipo Id.</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoPersona.idTipoIden">
                    <option disabled value="">Seleccione...</option>
                    <option v-for="t in tipoIdens" :value="t.idTipoIden" :key="t.idTipoIden">
                      {{ t.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2"><label class="form-label fw-bold">Documento</label></div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="datoPersona.documento" style="text-transform:uppercase" />
                </div>
                <div class="col-2"><label class="form-label fw-bold">Estado Civil</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoPersona.idEstadoCivil">
                    <option disabled value="">Seleccione...</option>
                    <option v-for="e in estadoCivils" :value="e.idEstadoCivil" :key="e.idEstadoCivil">
                      {{ e.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Fila: FechaNac / Sexo / Teléfono -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Fecha Nac.</label></div>
                <div class="col-2">
                  <input type="date" class="form-control" v-model="datoPersona.fechaNac" />
                </div>
                <div class="col-2"><label class="form-label fw-bold">Sexo</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoPersona.sexo">
                    <option value="">Seleccione...</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
                <div class="col-2"><label class="form-label fw-bold">Teléfono</label></div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="datoPersona.telefono" />
                </div>
              </div>
            </div>
            <!-- Fila: Nombres -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Primer Nombre</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.primerNombre" style="text-transform:uppercase" />
                </div>
                <div class="col-2"><label class="form-label fw-bold">Segundo Nombre</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.segundoNombre" style="text-transform:uppercase" />
                </div>
              </div>
            </div>
            <!-- Fila: Apellidos -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Primer Apellido</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.primerApellido" style="text-transform:uppercase" />
                </div>
                <div class="col-2"><label class="form-label fw-bold">Segundo Apellido</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.segundoApellido" style="text-transform:uppercase" />
                </div>
              </div>
            </div>
            <!-- Fila: Localidad / Email -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Localidad</label></div>
                <div class="col-4">
                  <select class="form-select" v-model="datoPersona.idLocalidad">
                    <option disabled value="">Seleccione...</option>
                    <option v-for="l in localidads" :value="l.idLocalidad" :key="l.idLocalidad">
                      {{ l.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2"><label class="form-label fw-bold">Email</label></div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="datoPersona.email" />
                </div>
              </div>
            </div>
            <!-- Dirección -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Dirección</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.direccion" style="text-transform:uppercase" />
                </div>
              </div>
            </div>
            <!-- Más información -->
            <button class="btn btn-outline-secondary btn-sm mb-2" @click.prevent="mostrarBloque = !mostrarBloque">
              {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
            </button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Fecha de registro</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPersona.fechaReg" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPersona"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarPersona"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      personas:          [],
      datoPersona:       {},
      cedulaBusqueda:    "",
      nombreBusqueda:    "",
      titulo:            "",
      btnCrear:          false,
      btnEditar:         false,
      modalWindow:       true,
      tipoIdens:         [],
      localidads:        [],
      estadoCivils:      [],
      mostrarBloque:     false,
      opcionConsulta:    0,
      opcionOperaciones: 0,
      opcionDescarga:    0,
      opcionMenu:        0,
    };
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.opcionConsulta    = parseInt(window.sessionStorage.getItem("opcionConsulta"),    10) || 0;
    this.opcionOperaciones = parseInt(window.sessionStorage.getItem("opcionOperaciones"), 10) || 0;
    this.opcionDescarga    = parseInt(window.sessionStorage.getItem("opcionDescarga"),    10) || 0;
    this.opcionMenu        = parseInt(window.sessionStorage.getItem("opcionMenu"),        10) || 0;
    this.getDataPaginaTodos();
    this.fetchTipoIdens();
    this.fetchLocalidads();
    this.fetchEstadoCivils();
  },
  methods: {
    // ── Búsqueda ──────────────────────────────────────────
    clearFields(field) {
      if (field !== "cedula") this.cedulaBusqueda = "";
      if (field !== "nombre") this.nombreBusqueda = "";
    },
    buscar() {
      const idEmpresa = window.sessionStorage.getItem("idEmpresa");
      let url = null;
      if (this.cedulaBusqueda) {
        url = `/vwpersonas/documento?documento=${this.cedulaBusqueda}&idempresa=${idEmpresa}`;
      } else if (this.nombreBusqueda) {
        url = `/vwpersonas/nombrecompleto?nombrecompleto=${this.nombreBusqueda}&idempresa=${idEmpresa}`;
      } else {
        this.getDataPaginaTodos();
        return;
      }
      api.get(url)
        .then(r => { this.personas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => {
          console.error("Error en búsqueda:", e);
          Swal.fire({ icon: "error", title: "Error", text: "No se encontraron datos." });
        });
    },
    // ── Carga de datos ────────────────────────────────────
    getDataPaginaTodos() {
      this.cedulaBusqueda = "";
      this.nombreBusqueda = "";
      const idEmpresa = window.sessionStorage.getItem("idEmpresa");
      api.get("/vwpersonas/idempresa/" + idEmpresa)
        .then(r => { this.personas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar personas:", e));
    },
    // ── Fetch auxiliares ──────────────────────────────────
    async fetchTipoIdens() {
      try { this.tipoIdens    = (await api.get("/vwtipoidens")).data;    } catch (e) { console.error(e); }
    },
    async fetchLocalidads() {
      try { this.localidads   = (await api.get("/vwlocalidads")).data;   } catch (e) { console.error(e); }
    },
    async fetchEstadoCivils() {
      try { this.estadoCivils = (await api.get("/vwestadocivils")).data; } catch (e) { console.error(e); }
    },
    // ── Validación ────────────────────────────────────────
    validarForm() {
      const fields = [
        "idTipoIden","idLocalidad","idEstadoCivil","documento",
        "primerNombre","segundoNombre","primerApellido","segundoApellido",
        "fechaNac","direccion","telefono","sexo","email",
      ];
      return validarForm(this.datoPersona, fields, fields);
    },
    // ── CRUD ──────────────────────────────────────────────
    async guardarPersona() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoPersona.idEmpresa   = window.sessionStorage.getItem("idEmpresa");
        this.datoPersona.tipoPersona = "N";
        await api.post("/personas", this.datoPersona);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Persona creada exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarPersona() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/personas", this.datoPersona);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Persona actualizada exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deletePersona(idPersona) {
      const confirm = await Swal.fire({
        title: "¿Eliminar persona?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/personas/" + idPersona);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    // ── Modales y navegación ──────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoPersona  = {};
      this.titulo       = "Crear Persona";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.mostrarBloque = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idPersona) {
      this.modalWindow   = true;
      this.titulo        = "Editar Persona";
      this.btnCrear      = false;
      this.btnEditar     = true;
      this.mostrarBloque = false;
      try {
        const resp       = await api.get("/vwpersonas/" + idPersona);
        this.datoPersona = resp.data;
      } catch (e) {
        console.error("Error al cargar persona:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idPersona) {
      if (idPersona != null) this.$router.push("/personaform/" + idPersona);
    },
    crearCita(idPersona) {
      if (idPersona != null) this.$router.push("/pacientecita02/" + idPersona + "/0/0");
    },
    crearNotificacion(idPersona, nombre) {
      if (idPersona != null) this.$router.push("/bitacoraform/" + idPersona + "/" + nombre);
    },
  },
};
</script>